module.exports = __webpack_public_path__ + "static/media/ic_why_hs3.4ac5d886.svg";